import { Category } from "./../models/category.models";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CondicionIva } from "app/models/condicionfrenteiva.models";
import { Brand } from "app/models/brand.models";
import { Tributo } from "app/models/tributo.models";
import { VoucherType } from "app/models/voucher-type.models";
import { environment } from "environments/environment";
import { Observable, Subscription } from "rxjs";
import { Province } from "app/models/province.models";
import { ReceiptBookEntity } from "app/models/receipt-book-entity.models";
import { PointOfSale } from "app/models/point-of-sale.models";
import { Currencie } from "app/models/currencie.models";

@Injectable({
  providedIn: "root",
})
export class ParametrosService {
  condicionivas: Observable<CondicionIva[] | any>;
  p: Subscription;

  constructor(private http: HttpClient) {}

  getParametrosArticulos(): Observable<any> {
    return this.http.get(environment.apiUrl + "articles/parameters");
  }

  getParametrosClientes(): Observable<any> {
    return this.http.get(environment.apiUrl + "client/parameters");
  }

  getParametrosComprobantes(): Observable<any> {
    return this.http.get(environment.apiUrl + "vouchers/parameters");
  }

  getCondicionIva() {
    this.p = this.http.get(environment.apiUrl + "iva-rate").subscribe();
    return this.p;
  }

  getMonedas(): Observable<Currencie[] | any> {
    return this.http.get(environment.apiUrl + "currency");
  }

  getMarcas(): Observable<Brand[] | any> {
    return this.http.get(environment.apiUrl + "brands");
  }

  getRubros(): Observable<Category[] | any> {
    return this.http.get(environment.apiUrl + "categories");
  }

  getTalonarios(receiptBookTypeId?: number): Observable<ReceiptBookEntity[] | any> {
    const url = receiptBookTypeId 
      ? `${environment.apiUrl}receipt-book?receiptBookTypeId=${receiptBookTypeId}`
      : `${environment.apiUrl}receipt-book`;
    return this.http.get(url);
  }

  getReceiptBookTypes(): Observable<any> {
    return this.http.get(environment.apiUrl + "receipt-book-type");
  }

  getVoucherTypesCode(): Observable<any> {
    return this.http.get(environment.apiUrl + "voucher-types-code");
  }

  getVoucherTypesCodeAfipByType(typeOperation: string): Observable<any> {
    return this.http.get(environment.apiUrl + `voucher-types-code-afip/type/${typeOperation}`);
  }

  getVoucherTypesCodeByType(typeOperation: string): Observable<any> {
    return this.http.get(environment.apiUrl + `voucher-types-code/type/${typeOperation}`);
  }

  getReceiptBookLetters(receiptBookTypeId?: number): Observable<any> {
    const url = receiptBookTypeId 
      ? `${environment.apiUrl}receipt-book-letters?receiptBookTypeId=${receiptBookTypeId}`
      : `${environment.apiUrl}receipt-book-letters`;
    return this.http.get(url);
  }

  getProvincias(): Observable<Province[] | any> {
    return this.http.get(environment.apiUrl + "province");
  }

  getPuntosDeVenta(): Observable<PointOfSale[] | any> {
    return this.http.get(environment.apiUrl + "sales-point");
  }

  getTipoVariantes(): Observable<PointOfSale[] | any> {
    return this.http.get(environment.apiUrl + "variant-type");
  }

  guardarTalonario(talonario: ReceiptBookEntity): Observable<ReceiptBookEntity | any> {
    return this.http.post(environment.apiUrl + "receipt-book", talonario);
  }

  guardarMarca(marca: Brand): Observable<Brand | any> {
    return this.http.post(environment.apiUrl + "brands", marca);
  }

  guardarRubro(rubro: Category): Observable<Category | any> {
    return this.http.post(environment.apiUrl + "categories", rubro);
  }

  getBancos(): Observable<Currencie[] | any> {
    return this.http.get(environment.apiUrl + "banks");
  }

  getTributos(): Observable<Tributo[] | any> {
    return this.http.get(environment.apiUrl + "tax");
  }

  getConceptos(): Observable<any> {
    return this.http.get(environment.apiUrl + "concept");
  }

  gettypeComprobantes(): Observable<any> {
    return this.http.get(environment.apiUrl + "typecomprobantes");
  }

  getMediosPagos(): Observable<any> {
    return this.http.get(environment.apiUrl + "payment-method");
  }

  modificarMarca(marca: Brand, id: number): Observable<any> {
    return this.http.patch(`${environment.apiUrl}brands/${id}`, marca);
  }

  borrarMarca(id: number): Observable<any> {
    return this.http.delete(`${environment.apiUrl}brands/${id}`);
  }

  modificarRubro(rubro: Category, id: number): Observable<any> {
    return this.http.patch(`${environment.apiUrl}categories/${id}`, rubro);
  }

  borrarRubro(id: number): Observable<any> {
    return this.http.delete(`${environment.apiUrl}categories/${id}`);
  }

  modificarTalonario(talonario: ReceiptBookEntity, id: number): Observable<any> {
    return this.http.patch(`${environment.apiUrl}receipt-book/${id}`, talonario);
  }

  deleteTalonario(id: number): Observable<any> {
    return this.http.delete(`${environment.apiUrl}receipt-book/${id}`);
  }

  getTalonarioById(id: number): Observable<any> {
    return this.http.get(`${environment.apiUrl}receipt-book/${id}`);
  }

  checkTalonarioHasVouchers(id: number): Observable<{ hasVouchers: boolean }> {
    return this.http.get<{ hasVouchers: boolean }>(`${environment.apiUrl}receipt-book/${id}/has-vouchers`);
  }

  // Métodos para VoucherType
  getVoucherTypes(operationType?: string, group?: string): Observable<VoucherType[] | any> {
    let url = `${environment.apiUrl}voucher-type`;
    const params: string[] = [];
    if (operationType) {
      params.push(`operationType=${operationType}`);
    }
    if (group) {
      params.push(`group=${group}`);
    }
    if (params.length) {
      url += `?${params.join('&')}`;
    }
    return this.http.get(url);
  }

  guardarVoucherType(voucherType: VoucherType): Observable<any> {
    return this.http.post(environment.apiUrl + "voucher-type", voucherType);
  }

  modificarVoucherType(voucherType: VoucherType, id: number): Observable<any> {
    return this.http.patch(`${environment.apiUrl}voucher-type/${id}`, voucherType);
  }

  borrarVoucherType(id: number): Observable<any> {
    return this.http.delete(`${environment.apiUrl}voucher-type/${id}`);
  }

  getVoucherTypeById(id: number): Observable<any> {
    return this.http.get(`${environment.apiUrl}voucher-type/${id}`);
  }

  getNextVoucherTypeCode(): Observable<{ nextCode: string }> {
    return this.http.get<{ nextCode: string }>(`${environment.apiUrl}voucher-type/next-code`);
  }
}
